export const environment = {
  urlAddress: 'http://localhost:5000',
};
